import { combineReducers } from "redux";
// import Models from "./Models";
import Caps from "./Caps";
// import Lookups from "./lookups";
import history from "./history";
import capsHistory from "./CapsHistory";
// import errors from "./errors";
import { emptySplitApi as rtkQueryBaseApi } from "../emptyApi";
const rootReducer = combineReducers({
  [rtkQueryBaseApi.reducerPath]: rtkQueryBaseApi.reducer,
  // Models,
  Caps,
  // Lookups,
  history,
  // errors,
  capsHistory: capsHistory,
});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
